export const CandyCane = ({ className = "" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Curved hook at top */}
      <path
        d="M 10 0 Q 14 0 16 5 Q 18 10 14 15"
        stroke="#DC2626"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M 10 0 Q 14 0 16 5 Q 18 10 14 15"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
      
      {/* Main body with diagonal stripes */}
      <rect x="0" y="15" width="20" height="65" fill="#DC2626" />
      
      {/* Diagonal white stripes */}
      <g transform="translate(0, 15)">
        {Array.from({ length: 8 }, (_, i) => (
          <rect
            key={i}
            x={-5 + (i * 5)}
            y={i * 8}
            width="20"
            height="8"
            fill="#FFFFFF"
            transform={`rotate(45 ${10 + (i * 5)} ${i * 8 + 4})`}
          />
        ))}
      </g>
    </svg>
  );
};

